module.exports = __webpack_public_path__ + "static/media/icon_voltaware.ed1933ac.svg";